import { SuggestionListItemNew, SuggestionsList } from './suggestions-list';
import { getProductElementIndex } from './utils/get-element-index';
import React from 'react';
import { NewSuggestion } from 'types/suggestions';
import { useSuggestionsButtonAction } from '../hooks/use-suggestions-button-action';
import { useTranslation } from 'react-i18next';

const DATA_QA_NEW_SUGGESTIONS_LIST = 'new-suggestions';

type NewSuggestionsListProps = {
  showProducts: boolean;
  suggestionSelector: string;
  isDefaultList: boolean;
  slicedNewSuggestions: NewSuggestion[];
  searchHref: string;
  index: number;
  buttonAction: ReturnType<typeof useSuggestionsButtonAction>;
  isSrp: boolean;
  showOnlyCategories: boolean;
  showAkinatorCompletions: boolean;
  akinatorOffset: number;
  defaultListPinnedOffset: number;
  itemIndexOffset?: number;
  withDivider?: boolean;
};

export const NewSuggestionsList: React.FC<NewSuggestionsListProps> = ({
  showProducts,
  suggestionSelector,
  slicedNewSuggestions,
  isDefaultList,
  index,
  isSrp,
  searchHref,
  buttonAction,
  showOnlyCategories,
  showAkinatorCompletions,
  akinatorOffset,
  defaultListPinnedOffset,
  itemIndexOffset = 0,
  withDivider,
}) => {
  const { t } = useTranslation();

  if (!showOnlyCategories && showProducts && slicedNewSuggestions.length > 0) {
    return (
      <SuggestionsList
        suggestionSelector={suggestionSelector}
        withTitle={false}
        withDivider={withDivider ?? (isDefaultList || showAkinatorCompletions)}
        title={t('header.searchbar.products')}
        aria-label={t('header.searchbar.products-aria')}
        data-qa={DATA_QA_NEW_SUGGESTIONS_LIST}
      >
        {slicedNewSuggestions.map((item, idx) => (
          <SuggestionListItemNew
            newSuggestion={item}
            elementIndex={getProductElementIndex(
              idx,
              isDefaultList,
              akinatorOffset,
              defaultListPinnedOffset,
              itemIndexOffset,
            )}
            navigationIndex={index}
            searchHref={searchHref}
            buttonAction={buttonAction}
            isSrp={isSrp}
            suggestionSelector={suggestionSelector}
            key={item.name}
          />
        ))}
      </SuggestionsList>
    );
  } else {
    return null;
  }
};
